// extracted by mini-css-extract-plugin
export default {"faq":"RouteConfirmation_faq__Av0gv","listStyle":"RouteConfirmation_listStyle__DmYqX"};